import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from '@store/cat-probe/CatProbeState';



export const catProbeSlice = createSlice({
	name: 'catProbe',
	initialState,
	reducers: {
		setShowInvalids: (state, action: PayloadAction<boolean>) => {
			state.showInvalids = action.payload
		},
		setNeckCircumference: (state, action: PayloadAction<number | null>) => {
			state.neckCircumference = action.payload;
		},
		setName: (state, action: PayloadAction<string | null>) => {
			state.name = action.payload;
		},
		setEmail: (state, action: PayloadAction<string | null>) => {
			state.email = action.payload;
		},
		setPhoneNumber: (state, action: PayloadAction<string | null>) => {
			state.phoneNumber = action.payload;
		},
		setCatName: (state, action: PayloadAction<string | null>) => {
			state.catName = action.payload;
		},
		setCompanyPhoneNumber: (state, action: PayloadAction<string | null>) => {
			state.companyPhoneNumber = action.payload;
		},
		setCompanyName: (state, action: PayloadAction<string | null>) => {
			state.companyName = action.payload;
		},
		setCompanyStreet: (state, action: PayloadAction<string | null>) => {
			state.companyStreet = action.payload;
		},
		setCompanyCity: (state, action: PayloadAction<string | null>) => {
			state.companyCity = action.payload;
		},
		setCompanyPostalCode: (state, action: PayloadAction<string | null>) => {
			state.companyPostalCode = action.payload;
		},
		setMessage: (state, action: PayloadAction<string | null>) => {
			state.message = action.payload;
		},
		resetStore: (state) => initialState,
	},
});

export default catProbeSlice.reducer;



export const {
	setShowInvalids,
	setNeckCircumference,
	setName,
	setEmail,
	setPhoneNumber,
	setCatName,
	setCompanyPhoneNumber,
	setCompanyName,
	setCompanyStreet,
	setCompanyCity,
	setCompanyPostalCode,
	setMessage,
	resetStore } = catProbeSlice.actions;